<template>
  <div class="h-auto ml-0 w-full lg:mr-3 min-h-screen">
    <div class="bg-white mx-3 mt-3 rounded-t-md border-b-0.5">
      <div class="flex justify-between items-center p-3">
        <p class="font-semibold lg:text-base text-sm">Documents Management</p>
      </div>
    </div>

    <div
      class="flex flex-wrap justify-between lg:divide-x-1.5 bg-gray-50 mx-3 mb- items-center border-0.5"
    >
      <router-link
        :to="{ name: 'documents-types', params: { type: menu.route } }"
        v-for="(menu, index) in subMenus"
        :key="index"
        :class="{
          'bg-primary text-white': selectedSubMenu == menu.name,
        }"
        class="text-sm text-center hover:bg-primary hover:text-white cursor-pointer lg:p-3 p-2 flex-grow"
      >
        {{ menu.name }}
      </router-link>
    </div>

    <DocumentsList
      :key="bTKey"
      v-if="selectedSubMenu == 'Document Types'"
    ></DocumentsList>
    <!-- <BenefitsManagement :key="bMTKey" v-if="selectedSubMenu == 'Benefits Management'"></BenefitsManagement> -->
  </div>
</template>

<script>
import DocumentsList from "@/components/CompanySetups/documentsSetups/documentsList.vue";
// import BenefitsManagement from "@/components/employees/tabs/benefitsManagement.vue";

export default {
  name: "DocumentsSetup",
  components: {
    DocumentsList,
    // BenefitsManagement
  },
  data() {
    return {
      bTKey: 0,
      bMTKey: 1,

      selectedSubMenu: "Document Types",
      subMenus: [
        {
          name: "Document Types",
          route: "documets-types",
        },
        {
          name: "Document Management",
          route: "documents-management",
        },
      ],
    };
  },
  watch: {
    $route(to) {
      this.subMenus.forEach((menu) => {
        if (menu.route == to.params.type) {
          this.selectedSubMenu = menu.name;
        }
      });
      switch (this.selectedSubMenu) {
        case "Document Types":
          this.bTKey++;
          break;
        case "Benefits Management":
          this.bMTKey++;
          break;
      }
    },
  },
};
</script>
